import { render, staticRenderFns } from "./ClassroomList.vue?vue&type=template&id=3a7d7c96"
import script from "./ClassroomList.vue?vue&type=script&lang=js"
export * from "./ClassroomList.vue?vue&type=script&lang=js"
import style0 from "./ClassroomList.vue?vue&type=style&index=0&id=3a7d7c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports